var map = {
	"./": 138,
	"./App": 189,
	"./App.css": 1150,
	"./App.js": 189,
	"./App.scss": 418,
	"./bufficorn.png": 135,
	"./burnerloader.gif": 132,
	"./burnerwallet.png": 290,
	"./coinbase.jpg": 1151,
	"./components/Admin": 209,
	"./components/Admin.js": 209,
	"./components/Advanced": 208,
	"./components/Advanced.js": 208,
	"./components/Badge": 84,
	"./components/Badge.js": 84,
	"./components/Badges": 203,
	"./components/Badges.js": 203,
	"./components/Balance": 24,
	"./components/Balance.js": 24,
	"./components/BalanceDisplay": 447,
	"./components/BalanceDisplay.jsx": 447,
	"./components/Bottom": 26,
	"./components/Bottom.js": 26,
	"./components/BottomLinks": 262,
	"./components/BottomLinks.js": 262,
	"./components/BurnWallet": 213,
	"./components/BurnWallet.js": 213,
	"./components/CashOut": 205,
	"./components/CashOut.js": 205,
	"./components/Exchange": 214,
	"./components/Exchange.js": 214,
	"./components/Footer": 212,
	"./components/Footer.js": 212,
	"./components/Header": 193,
	"./components/Header.js": 193,
	"./components/History": 207,
	"./components/History.js": 207,
	"./components/Loader": 78,
	"./components/Loader.js": 78,
	"./components/MainCard": 206,
	"./components/MainCard.js": 206,
	"./components/Modal": 448,
	"./components/Modal.js": 448,
	"./components/MoreButtons": 87,
	"./components/MoreButtons.js": 87,
	"./components/NavCard": 23,
	"./components/NavCard.js": 23,
	"./components/Receipt": 204,
	"./components/Receipt.js": 204,
	"./components/Receive": 200,
	"./components/Receive.js": 200,
	"./components/RecentTransactions": 77,
	"./components/RecentTransactions.js": 77,
	"./components/RequestFunds": 198,
	"./components/RequestFunds.js": 198,
	"./components/Ruler": 14,
	"./components/Ruler.js": 14,
	"./components/SendBadge": 196,
	"./components/SendBadge.js": 196,
	"./components/SendByScan": 194,
	"./components/SendByScan.js": 194,
	"./components/SendToAddress": 195,
	"./components/SendToAddress.js": 195,
	"./components/SendWithLink": 199,
	"./components/SendWithLink.js": 199,
	"./components/Share": 201,
	"./components/Share.js": 201,
	"./components/ShareLink": 202,
	"./components/ShareLink.js": 202,
	"./components/Vendor": 210,
	"./components/Vendor.js": 210,
	"./components/Vendors": 211,
	"./components/Vendors.js": 211,
	"./components/WithdrawFromPrivate": 197,
	"./components/WithdrawFromPrivate.js": 197,
	"./contracts/Badges.abi": 264,
	"./contracts/Badges.abi.js": 264,
	"./contracts/Badges.address": 272,
	"./contracts/Badges.address.js": 272,
	"./contracts/Badges.blocknumber": 449,
	"./contracts/Badges.blocknumber.js": 449,
	"./contracts/Badges.bytecode": 450,
	"./contracts/Badges.bytecode.js": 450,
	"./contracts/BuffiDai.abi": 265,
	"./contracts/BuffiDai.abi.js": 265,
	"./contracts/BuffiDai.address": 273,
	"./contracts/BuffiDai.address.js": 273,
	"./contracts/BuffiDai.blocknumber": 451,
	"./contracts/BuffiDai.blocknumber.js": 451,
	"./contracts/BuffiDai.bytecode": 452,
	"./contracts/BuffiDai.bytecode.js": 452,
	"./contracts/Burner.abi": 266,
	"./contracts/Burner.abi.js": 266,
	"./contracts/Burner.address": 274,
	"./contracts/Burner.address.js": 274,
	"./contracts/Burner.blocknumber": 453,
	"./contracts/Burner.blocknumber.js": 453,
	"./contracts/Burner.bytecode": 454,
	"./contracts/Burner.bytecode.js": 454,
	"./contracts/BurnerVendor.abi": 267,
	"./contracts/BurnerVendor.abi.js": 267,
	"./contracts/BurnerVendor.address": 275,
	"./contracts/BurnerVendor.address.js": 275,
	"./contracts/BurnerVendor.blocknumber": 455,
	"./contracts/BurnerVendor.blocknumber.js": 455,
	"./contracts/BurnerVendor.bytecode": 456,
	"./contracts/BurnerVendor.bytecode.js": 456,
	"./contracts/DenDai.abi": 268,
	"./contracts/DenDai.abi.js": 268,
	"./contracts/DenDai.address": 276,
	"./contracts/DenDai.address.js": 276,
	"./contracts/DenDai.blocknumber": 457,
	"./contracts/DenDai.blocknumber.js": 457,
	"./contracts/DenDai.bytecode": 458,
	"./contracts/DenDai.bytecode.js": 458,
	"./contracts/ENS.abi": 183,
	"./contracts/ENS.abi.js": 183,
	"./contracts/ENS.address": 187,
	"./contracts/ENS.address.js": 187,
	"./contracts/ENS.blocknumber": 459,
	"./contracts/ENS.blocknumber.js": 459,
	"./contracts/ENSResolver.abi": 184,
	"./contracts/ENSResolver.abi.js": 184,
	"./contracts/ENSResolver.blocknumber": 460,
	"./contracts/ENSResolver.blocknumber.js": 460,
	"./contracts/ERC20Vendable.abi": 269,
	"./contracts/ERC20Vendable.abi.js": 269,
	"./contracts/ERC20Vendable.address": 277,
	"./contracts/ERC20Vendable.address.js": 277,
	"./contracts/ERC20Vendable.blocknumber": 461,
	"./contracts/ERC20Vendable.blocknumber.js": 461,
	"./contracts/ERC20Vendable.bytecode": 462,
	"./contracts/ERC20Vendable.bytecode.js": 462,
	"./contracts/Emitter.abi": 185,
	"./contracts/Emitter.abi.js": 185,
	"./contracts/Emitter.address": 188,
	"./contracts/Emitter.address.js": 188,
	"./contracts/Emitter.blocknumber": 463,
	"./contracts/Emitter.blocknumber.js": 463,
	"./contracts/Emitter.bytecode": 464,
	"./contracts/Emitter.bytecode.js": 464,
	"./contracts/Exchange.abi": 182,
	"./contracts/Exchange.abi.js": 182,
	"./contracts/Exchange.address": 278,
	"./contracts/Exchange.address.js": 278,
	"./contracts/Exchange.blocknumber": 465,
	"./contracts/Exchange.blocknumber.js": 465,
	"./contracts/Links.abi": 270,
	"./contracts/Links.abi.js": 270,
	"./contracts/Links.address": 279,
	"./contracts/Links.address.js": 279,
	"./contracts/Links.blocknumber": 466,
	"./contracts/Links.blocknumber.js": 466,
	"./contracts/Links.bytecode": 467,
	"./contracts/Links.bytecode.js": 467,
	"./contracts/StableCoin.abi": 186,
	"./contracts/StableCoin.abi.js": 186,
	"./contracts/StableCoin.address": 280,
	"./contracts/StableCoin.address.js": 280,
	"./contracts/StableCoin.blocknumber": 468,
	"./contracts/StableCoin.blocknumber.js": 468,
	"./contracts/StableCoin.bytecode": 469,
	"./contracts/StableCoin.bytecode.js": 469,
	"./contracts/VendingMachine.abi": 271,
	"./contracts/VendingMachine.abi.js": 271,
	"./contracts/VendingMachine.address": 281,
	"./contracts/VendingMachine.address.js": 281,
	"./contracts/VendingMachine.blocknumber": 470,
	"./contracts/VendingMachine.blocknumber.js": 470,
	"./contracts/VendingMachine.bytecode": 471,
	"./contracts/VendingMachine.bytecode.js": 471,
	"./contracts/contracts": 472,
	"./contracts/contracts.js": 472,
	"./customRPCHint.png": 217,
	"./cypherpunk.png": 136,
	"./dai.jpg": 218,
	"./ethereum.png": 111,
	"./i18n": 1,
	"./i18n/": 1,
	"./i18n/index": 1,
	"./i18n/index.js": 1,
	"./i18n/locales": 63,
	"./i18n/locales/": 63,
	"./i18n/locales/ca": 151,
	"./i18n/locales/ca.json": 151,
	"./i18n/locales/de": 152,
	"./i18n/locales/de.json": 152,
	"./i18n/locales/en": 148,
	"./i18n/locales/en.json": 148,
	"./i18n/locales/es": 150,
	"./i18n/locales/es.json": 150,
	"./i18n/locales/fr": 149,
	"./i18n/locales/fr.json": 149,
	"./i18n/locales/index": 63,
	"./i18n/locales/index.js": 63,
	"./i18n/locales/ro": 153,
	"./i18n/locales/ro.json": 153,
	"./index": 138,
	"./index.js": 138,
	"./index.scss": 296,
	"./localeth.png": 1152,
	"./qrcode.png": 289,
	"./sendwyre.png": 1153,
	"./services/wyre": 110,
	"./services/wyre.js": 110,
	"./wyre.jpg": 1154,
	"./wyre.png": 291,
	"./xdai.jpg": 137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1149;